module.exports = __webpack_public_path__ + "static/media/ico_stickercontest_wacomlogo.e703a748.png";